module.exports = __webpack_public_path__ + "img/health-index.c4e7512a.png";